module.exports = __webpack_public_path__ + "static/img/business2.75e0b77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business2.jpg
// module id = CLfS
// module chunks = 9